import { useIntl } from 'react-intl';

import { ContactForm } from '../../../features/contact-form';

import { clsx } from 'clsx';

import ContourBackdrop from '../../ContourBackdrop/ContourBackdrop';

import styles from './contact.module.css';

export function Contact() {
	const intl = useIntl();

	return (
		<section className={styles.contact} aria-labelledby='contact-title'>
			<ContourBackdrop className={styles.contoursRight} rings={7} from={3.4} />
			<ContourBackdrop className={styles.contoursLeft} rings={7} from={3.4} />
			<div className={clsx('container', styles.wrapper)}>
				<header className={styles.header}>
					<h1 className={styles.title} id='contact-title'>
						{intl.formatMessage({ id: 'ContactUsId2' })}
					</h1>
					<p className={styles.description}>
						{intl.formatMessage({ id: 'ContactUsId3' })}
					</p>
				</header>

				<div className={styles.card}>
					<h2 className={styles.cardTitle}>
						{intl.formatMessage({ id: 'ContactUsId1' })}
					</h2>

					<ContactForm />
				</div>
			</div>
		</section>
	);
}
